const Italic = ({ children }: { children: React.ReactNode }) => {
  return <em>{children}</em>;
};

export default Italic;
